'use strict';

/** @deprecated This function is a no-op in Reanimated 4. */
export function addWhitelistedNativeProps(_props) {
  // Do nothing. This is just for backward compatibility.
}

/** @deprecated This function is a no-op in Reanimated 4. */
export function addWhitelistedUIProps(_props) {
  // Do nothing. This is just for backward compatibility.
}
//# sourceMappingURL=deprecated.js.map